import ActionMutations from './mutations-types'

export default {
  [ActionMutations.SET_ACTIONS](state, actions) {
    state.actions = [...actions]
  },

  [ActionMutations.SET_SELECTED_ACTION](state, action) {
    state.selectedAction = action

    state.fields.forEach((field) => {
      field.value = null

      if (action) {
        field.value = action[field.name]
      }
    })
  },

  [ActionMutations.SET_FIELD_TENANTS](state, tenants) {
    state.fields.find(f => f.name == 'tenant_id').items = tenants
  },

  [ActionMutations.SET_TENANT_PERMISSIONS](state, { isMaster, tenants }) {
    const tenantField = state.fields.find(f => f.name == 'tenant_id')
    
    if (isMaster) {
      // Master cannot select tenant_id in create mode
      if (!state.selectedAction) {
        tenantField.hide = true
        tenantField.required = false
        tenantField.rules = []
        tenantField.value = null
      } else {
        // In edit mode, show tenant field but make it readonly if action has tenant_id
        tenantField.hide = false
        tenantField.required = false
        tenantField.rules = []
        tenantField.readonly = state.selectedAction.tenant_id !== null && state.selectedAction.tenant_id !== undefined
      }
    } else {
      // Admin must select tenant_id in create mode
      if (!state.selectedAction) {
        tenantField.hide = false
        tenantField.required = true
        tenantField.rules = [
          v => !!v || 'Tenant is required for Admin users'
        ]
      } else {
        // In edit mode, show tenant field and allow editing if action has tenant_id
        tenantField.hide = false
        tenantField.required = false
        tenantField.rules = []
        tenantField.readonly = false
      }
    }
    
    tenantField.items = tenants
  }
}
